/* DEAD PROTOCOL theme script. The site's script with its data moved to Shopify:
   Liquid renders the pages; this file keeps the motion (marquees, scramble, feed, clocks), the panels,
   the gallery + buy box, the AJAX cart drawer, the search overlay and the form checks. */
(() => {
'use strict';
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const esc = s => String(s).replace(/[&<>"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ---------- config from Liquid (snippets/dp-config.liquid) ---------- */
const cfgEl = document.getElementById('dp-config');
let DP = { t: {}, routes: {} };
try { if (cfgEl) DP = JSON.parse(cfgEl.textContent); } catch(e){}
const R = DP.routes || {};
const decode = s => { const d = document.createElement('textarea'); d.innerHTML = s; return d.value; };
const T = {}; for (const k in (DP.t || {})) T[k] = decode(DP.t[k]);
const t = (k, v) => { let s = T[k]; if (s == null) return k; if (v) for (const x in v) s = s.split('{' + x + '}').join(v[x]); return s; };

/* ---------- money: the store's money format, without trailing zeros (₺1.400) ---------- */
const FMT = String(DP.moneyFormat || '{{amount}}').replace(/<[^>]*>/g, '');
const KINDS = { amount:[2,',','.'], amount_no_decimals:[0,',','.'], amount_with_comma_separator:[2,'.',','], amount_no_decimals_with_comma_separator:[0,'.',','], amount_with_space_separator:[2,' ',','], amount_no_decimals_with_space_separator:[0,' ',','], amount_with_apostrophe_separator:[2,"'",'.'], amount_with_period_and_space_separator:[2,' ','.'] };
function money(cents){
  const m = FMT.match(/\{\{\s*(\w+)\s*\}\}/), [d, th, dc] = KINDS[m ? m[1] : 'amount'] || KINDS.amount;
  const [i, f] = (Math.round(cents) / 100).toFixed(d).split('.');
  const s = i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (f && +f ? dc + f : '');
  return FMT.replace(/\{\{\s*\w+\s*\}\}/, s);
}

/* ---------- marquees: enough copies to always overfill the screen, so the loop never shows its end ---------- */
let MQ = [];
function initMarquees(root){
  const add = $$('.marquee .track', root).map(el => ({ el, html: el.firstElementChild ? el.firstElementChild.innerHTML : el.innerHTML }));
  MQ = MQ.filter(m => m.el.isConnected).concat(add);
  add.forEach(layoutMarquee);
}
function layoutMarquee(m){
  const { el, html } = m;
  el.innerHTML = `<span>${html}</span>`;
  const one = el.firstElementChild.getBoundingClientRect().width || 1;
  const vw = Math.max(window.innerWidth, document.documentElement.clientWidth, screen.width || 0);
  const n = Math.max(1, Math.ceil((vw + 40) / one));
  const unit = `<span>${html}</span>`.repeat(n);
  el.innerHTML = unit + unit;
  const sec = parseFloat(getComputedStyle(el.parentElement).getPropertyValue('--speed')) || 38;
  el.style.animationDuration = (sec * n) + 's';
}
let mqW = window.innerWidth, mqT;
window.addEventListener('resize', () => { clearTimeout(mqT); mqT = setTimeout(() => { if (window.innerWidth === mqW) return; mqW = window.innerWidth; MQ.forEach(layoutMarquee); }, 150); });
if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => MQ.forEach(layoutMarquee));

/* ---------- panels ---------- */
let openPanel = null, lastFocus = null;
function openP(id){
  const el = document.getElementById(id); if (!el) return;
  if (openPanel && openPanel !== el) closeP(true);
  lastFocus = lastFocus || document.activeElement;
  el.classList.add('open'); el.removeAttribute('inert'); el.setAttribute('aria-hidden','false');
  const scrim = $('#scrim'); if (scrim) scrim.classList.add('on');
  document.body.classList.add('lock'); openPanel = el;
  const f = el.querySelector('[data-autofocus]') || el.querySelector('button, a, input');
  setTimeout(() => f && f.focus(), 60);
  if (id === 'search') renderSearch();
}
function closeP(keepFocus){
  if (!openPanel) return;
  openPanel.classList.remove('open'); openPanel.setAttribute('inert',''); openPanel.setAttribute('aria-hidden','true');
  const scrim = $('#scrim'); if (scrim) scrim.classList.remove('on');
  document.body.classList.remove('lock'); openPanel = null;
  if (!keepFocus && lastFocus && lastFocus.focus) lastFocus.focus(); if (!keepFocus) lastFocus = null;
}
document.addEventListener('click', e => {
  const o = e.target.closest('[data-open]'); if (o){ if (document.getElementById(o.dataset.open)){ e.preventDefault(); openP(o.dataset.open); } return; }
  const c = e.target.closest('[data-close]'); if (c){ const isLink = c.tagName === 'A'; closeP(isLink); if (!isLink) e.preventDefault(); }
});
if ($('#scrim')) $('#scrim').onclick = () => closeP();
document.addEventListener('keydown', e => { if (e.key === 'Escape') closeP(); });
$$('#menu a').forEach(a => a.addEventListener('click', () => closeP(true)));

/* ---------- toast ---------- */
let tt; function toast(s){ const el = $('#toast'); if (!el) return; $('#toast-t').textContent = s; el.classList.add('on'); clearTimeout(tt); tt = setTimeout(() => el.classList.remove('on'), 2400); }

/* ---------- cart (Shopify AJAX Cart API; the drawer is re-rendered by Liquid via sections=cart-drawer) ---------- */
const cartPost = (url, body) => fetch(url, {
  method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
  body: JSON.stringify(Object.assign({}, body, { sections: 'cart-drawer', sections_url: location.pathname }))
}).then(r => r.json().catch(() => ({})).then(j => { if (!r.ok) throw j; return j; }));
function paintCart(html){
  if (!html) return;
  const doc = new DOMParser().parseFromString(html, 'text/html');
  ['cart-n', 'ship-bar', 'cart-lines', 'cart-foot'].forEach(id => { const a = document.getElementById(id), b = doc.getElementById(id); if (a && b) a.replaceWith(document.importNode(b, true)); });
  const ul = $('#cart-lines'), n = ul ? +ul.dataset.count || 0 : 0;
  const cc = $('#cart-count'); if (cc){ cc.textContent = n; cc.hidden = n === 0; }
}
function addToCart(id, qty, label, msgEl){
  return cartPost(R.cartAdd + '.js', { items: [{ id, quantity: qty }] }).then(j => {
    if (DP.isCart){ location.reload(); return; }
    paintCart(j.sections && j.sections['cart-drawer']);
    toast(`${t('toast.added')}: ${label}`);
    setTimeout(() => openP('cart'), 250);
  }).catch(err => { if (msgEl) msgEl.textContent = (err && (err.description || err.message)) || t('cart.error'); });
}
document.addEventListener('click', e => {
  const b = e.target.closest('.cart-lines [data-dec], .cart-lines [data-inc], .cart-lines [data-rm]'); if (!b) return;
  const d = b.dataset, key = d.dec || d.inc || d.rm, q = +d.q || 0;
  let next = 0;
  if (d.dec !== undefined) next = q - 1;
  else if (d.inc !== undefined){ next = Math.min(+d.max || 99, q + 1); if (next === q) return; }
  b.disabled = true;
  cartPost(R.cartChange + '.js', { id: key, quantity: Math.max(0, next) })
    .then(j => { if (DP.isCart) return location.reload(); paintCart(j.sections && j.sections['cart-drawer']); })
    .catch(() => location.reload());
});

/* ---------- gallery + buy box (spotlight + product page) ---------- */
const sized = (u, w) => String(u).replace(/width=\d+/, 'width=' + w);
function productView(root){
  const dataEl = $('.js-pdata', root); if (!dataEl) return;
  let P; try { P = JSON.parse(dataEl.textContent); } catch(e){ return; }
  const galEl = $('.gal', root), boxEl = $('.buybox', root), mode = root.dataset.mode;
  const nameOf = k => { const x = P.models.find(m => m.k === k); return x ? x.name : ''; };
  let m0 = P.m0;
  if (root.hasAttribute('data-main')){ const qm = new URLSearchParams(location.search).get('model'); if (qm && P.models.some(m => m.k === qm)) m0 = qm; }
  let box = null;
  const gal = gallery(P, galEl, mode, nameOf, k => box && box.model(k));
  box = buyBox(P, boxEl, m0, nameOf, gal);
  gal.model(m0);
}
function gallery(P, el, mode, nameOf, onPick){
  // only the current model's photo plus the detail shots (no model); the model buttons switch it
  const all = P.imgs || []; let cur = null, list = all, i = 0;
  const lbl = x => x.m ? nameOf(x.m) : t('v.detail');
  const img = (x, cls = '', w = 700) => `<img${cls || !x.m ? ` class="${cls}${x.m ? '' : ' fit'}"` : ''} src="${esc(sized(x.src, w))}" alt="" loading="lazy">`;
  const draw = () => {
    const x = list[i]; if (!x) return;
    el.innerHTML = `<div class="shot"><span class="tags">${P.tags || ''}</span><img${x.m ? '' : ' class="fit"'} src="${esc(sized(x.src, 1400))}" alt="${esc(P.title)}, ${esc(lbl(x))}"></div>` + (list.length < 2 ? '' : mode === 'arrows'
      ? `<div class="gal-ctrl"><button type="button" class="js-prev" aria-label="${esc(t('v.prev'))}">←</button><span>${i+1} / ${list.length} · ${esc(lbl(x))}</span><button type="button" class="js-next" aria-label="${esc(t('v.next'))}">→</button></div>`
      : `<div class="thumbs">${list.map((y, k) => `<button type="button" aria-pressed="${k===i}" aria-label="${esc(lbl(y))} ${esc(t('v.show'))}" data-i="${k}"><span class="shot">${img(y, '', 300)}</span></button>`).join('')}</div>`);
    el.querySelectorAll('.js-prev').forEach(b => b.onclick = () => go((i + list.length - 1) % list.length, '.js-prev'));
    el.querySelectorAll('.js-next').forEach(b => b.onclick = () => go((i + 1) % list.length, '.js-next'));
    el.querySelectorAll('[data-i]').forEach(b => b.onclick = () => go(+b.dataset.i, `[data-i="${b.dataset.i}"]`));
  };
  const go = (k, refocus) => { i = k; draw(); if (refocus){ const f = el.querySelector(refocus); if (f) f.focus(); } };
  const model = m => {
    if (!all.some(x => x.m === m) && cur !== null) return;
    cur = m; list = all.filter(x => !x.m || x.m === m); if (!list.length) list = all;
    i = Math.max(0, list.findIndex(x => x.m === m)); draw();
  };
  return { model };
}
function buyBox(P, el, m0, nameOf, gal){
  const needSize = P.sizes.length > 0;
  let m = P.models.some(x => x.k === m0) ? m0 : (P.models[0] || {}).k, size = null, qty = 1;
  const q = $('.js-q', el), msg = $('.js-msg', el);
  const vars = k => P.variants.filter(v => v.m === k);
  const vOf = (k, s) => P.variants.find(v => v.m === k && (!needSize || v.s === s));
  const cap = v => v && v.track && !v.cont ? Math.max(0, v.qty) : 9;
  const units = v => v && v.track ? Math.max(0, v.qty) : 0;
  const priceHTML = k => {
    const vs = vars(k); if (!vs.length) return '';
    const v = vs.reduce((a, b) => b.price < a.price ? b : a, vs[0]);
    const pct = v.compare > v.price ? Math.round((v.compare - v.price) / v.compare * 100) : 0;
    return (pct ? `<s>${money(v.compare)}</s><span class="now-sale">${money(v.price)}</span>` : `<span>${money(v.price)}</span>`) + (pct ? `<span class="tag tag-red">${esc(t('tag.off', { n: pct }))}</span>` : '');
  };
  const setStock = () => {
    const sl = $('.js-sl', el); if (!sl) return;
    if (size){ const n = units(vOf(m, size)); sl.textContent = t('pdp.left') + ' · ' + size; $('.js-left', el).textContent = n; $('.js-meter', el).style.width = Math.min(100, n * 3 / 40 * 100) + '%'; }
    else { const n = vars(m).reduce((a, v) => a + units(v), 0); sl.textContent = t('pdp.left'); $('.js-left', el).textContent = n; $('.js-meter', el).style.width = Math.min(100, n / 40 * 100) + '%'; }
  };
  const setModel = k => {
    m = k;
    $$('.js-m', el).forEach(b => b.setAttribute('aria-checked', b.dataset.m === m));
    const pe = $('.js-price', el); if (pe) pe.innerHTML = priceHTML(m);
    const se = $('.js-specs', el); if (se) se.innerHTML = ((P.specs || {})[m] || []).map(s => `<li>${esc(s)}</li>`).join('');
    $$('.js-s', el).forEach(b => {
      const v = vOf(m, b.dataset.size), off = !v || !v.avail;
      b.disabled = off; if (off) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
      if (off && size === b.dataset.size){ size = null; b.setAttribute('aria-checked', 'false'); }
    });
    if (size){ qty = Math.max(1, Math.min(qty, cap(vOf(m, size)))); q.textContent = qty; }
    setStock();
  };
  setModel(m);
  $$('.js-m', el).forEach(b => b.onclick = () => { setModel(b.dataset.m); if (gal) gal.model(m); });
  const max = () => size ? cap(vOf(m, size)) : 1;
  $$('.js-s', el).forEach(b => b.onclick = () => {
    size = b.dataset.size; qty = Math.max(1, Math.min(qty, max())); q.textContent = qty;
    $$('.js-s', el).forEach(x => x.setAttribute('aria-checked', x === b));
    setStock();
    msg.textContent = '';
  });
  $('.js-minus', el).onclick = () => { qty = Math.max(1, qty - 1); q.textContent = qty; };
  $('.js-plus', el).onclick = () => { qty = Math.min(size ? max() : 9, qty + 1); q.textContent = qty; };
  const add = $('.js-add', el);
  add.onclick = () => {
    if (needSize && !size){ msg.textContent = t('pdp.pick'); const f = el.querySelector('.js-s:not([disabled])'); if (f) f.focus(); return; }
    const v = vOf(m, size);
    if (!v || !v.avail){ msg.textContent = t('tag.sold'); return; }
    msg.textContent = '';
    add.disabled = true;
    addToCart(v.id, qty, `${P.title} · ${nameOf(m)}${size ? ' · ' + size : ''}`, msg).then(() => { add.disabled = false; });
  };
  return { model(k){ if (P.models.some(x => x.k === k)) setModel(k); } };
}

/* ---------- search: the overlay lists the catalogue; filter it with the Turkish fold, then ask Shopify ---------- */
// fold case and Turkish dots/accents, so "incels" finds INCEL and "tisort" finds TİŞÖRT
const fold = s => String(s).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/ı/g, 'i');
let sT = 0, sN = 0;
function renderSearch(){
  const box = $('#results'), inp = $('#q'); if (!box || !inp) return;
  const raw = inp.value.trim(), q = fold(raw);
  $$('.js-remote, .empty', box).forEach(x => x.remove());
  let hits = 0;
  $$('a[data-s]', box).forEach(a => { const ok = !q || fold(a.dataset.s).includes(q); a.hidden = !ok; if (ok) hits++; });
  const n = ++sN; clearTimeout(sT);
  if (hits || !q) return;
  const none = () => box.insertAdjacentHTML('beforeend', `<p class="empty" style="grid-column:1/-1">${t('search.none', { q: esc(raw) })}</p>`);
  if (!R.predictive){ none(); return; }
  sT = setTimeout(() => {
    const url = `${R.predictive}.json?q=${encodeURIComponent(raw)}&resources[type]=product&resources[limit]=12&resources[options][fields]=title,product_type,variants.title,tag`;
    fetch(url, { headers: { Accept: 'application/json' } }).then(r => r.ok ? r.json() : null).catch(() => null).then(j => {
      if (n !== sN) return;
      const list = (j && j.resources && j.resources.results && j.resources.results.products) || [];
      if (!list.length){ none(); return; }
      box.insertAdjacentHTML('beforeend', list.map(p => `<a class="js-remote" href="${esc(p.url)}" data-close><span class="shot">${p.image ? `<img src="${esc(p.image)}" alt="" loading="lazy">` : ''}</span><span lang="en">${esc(p.title)}</span><span class="card-sub">${money(Math.round(parseFloat(p.price) * 100))}</span></a>`).join(''));
    });
  }, 160);
}
if ($('#q')) $('#q').addEventListener('input', renderSearch);

/* ---------- shop sort ---------- */
const sortSel = $('#sort');
if (sortSel) sortSel.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', sortSel.value); u.searchParams.delete('page'); location.href = u.toString(); });

/* ---------- live feed (media division) ----------
   Centre camera cycles through the network's photos; both side cameras have lost the signal. */
const initFeed = cam => {
  const ph = $$('.ph', cam); if (ph.length < 2) return;
  let at = Math.max(0, ph.findIndex(x => x.classList.contains('on')));
  const swap = () => {
    at = (at + 1) % ph.length;
    ph.forEach((el, i) => el.classList.toggle('on', i === at));
    const loc = $('.js-loc', cam); if (loc) loc.textContent = 'CAM 02 // ' + (ph[at].dataset.loc || '');
  };
  const next = () => {
    if (reduce){ swap(); return; }
    cam.classList.add('glitch');
    setTimeout(() => { swap(); setTimeout(() => cam.classList.remove('glitch'), 140); }, 160);
  };
  const id = setInterval(() => { if (!cam.isConnected) return clearInterval(id); if (!document.hidden) next(); }, +cam.dataset.interval || 3400);
};

/* ---------- clocks ---------- */
const pad = n => String(n).padStart(2, '0');
function tick(){
  $$('[data-drop]').forEach(el => {
    const at = new Date(el.dataset.drop).getTime(), d = $('.js-cd-d', el), h = $('.js-cd-h', el), m = $('.js-cd-m', el), sx = $('.js-cd-s', el);
    if (isNaN(at) || !d || !h || !m || !sx) return;
    let s = Math.max(0, Math.floor((at - Date.now()) / 1000));
    d.textContent = pad(Math.floor(s / 86400)); s %= 86400;
    h.textContent = pad(Math.floor(s / 3600)); s %= 3600;
    m.textContent = pad(Math.floor(s / 60)); sx.textContent = pad(s % 60);
  });
  let now;
  try { now = new Date().toLocaleTimeString('en-GB', { timeZone: DP.tz || 'Europe/Istanbul', hour12: false }); } catch(e){ now = new Date().toTimeString().slice(0, 8); }
  $$('.js-clock').forEach(el => el.textContent = (el.dataset.city ? el.dataset.city + ' ' : '') + now);
  $$('.js-ts').forEach(el => el.textContent = now);
}

/* ---------- forms: same checks as the site, then the real Shopify submit ---------- */
const emailOk = v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
document.addEventListener('submit', e => {
  const f = e.target;
  if (f.classList.contains('js-signup')){
    const inp = f.querySelector('input[type="email"]'), m = f.parentElement.querySelector('.form-msg');
    if (inp && !emailOk(inp.value.trim())){ e.preventDefault(); if (m) m.textContent = t('sig.bad'); inp.focus(); }
  } else if (f.id === 'contact-form'){
    const m = $('#contact-msg'), name = $('#c-name', f), mail = $('#c-email', f), body = $('#c-msg', f);
    if (!name.value.trim()){ e.preventDefault(); m.textContent = t('form.name'); name.focus(); return; }
    if (!emailOk(mail.value.trim())){ e.preventDefault(); m.textContent = t('form.email'); mail.focus(); return; }
    if (body.value.trim().length < 5){ e.preventDefault(); m.textContent = t('form.msg'); body.focus(); return; }
  } else if (f.classList.contains('js-track')){
    e.preventDefault(); const m = $('#track-msg'), o = $('#t-order').value.trim();
    if (!/^#?[A-Z]{0,6}\d{3,}$/i.test(o)){ m.textContent = t('track.badOrder'); $('#t-order').focus(); return; }
    if (!emailOk($('#t-email').value.trim())){ m.textContent = t('track.badEmail'); $('#t-email').focus(); return; }
    m.textContent = t('track.go');
    setTimeout(() => { location.href = R.account || f.action; }, 700);
  }
});
document.addEventListener('click', e => {
  const b = e.target.closest('#copy-mail'); if (!b) return;
  const s = $('#mail').textContent;
  const done = () => { b.textContent = t('copied'); setTimeout(() => b.textContent = t('copy'), 1600); };
  const fallback = () => { const r = document.createRange(); r.selectNodeContents($('#mail')); const sel = getSelection(); sel.removeAllRanges(); sel.addRange(r); b.textContent = t('selected'); };
  try { navigator.clipboard.writeText(s).then(done, fallback); } catch(err){ fallback(); }
});

/* ---------- decrypt headline ---------- */
function scramble(el, delay){
  const final = el.textContent, chars = '█▓▒░#/<>_01ΔΣ';
  let f = 0;
  setTimeout(() => {
    const id = setInterval(() => {
      el.textContent = [...final].map((ch, i) => ch === ' ' || i < f / 2 ? ch : chars[Math.random() * chars.length | 0]).join('');
      if (++f > final.length * 2 + 1){ clearInterval(id); el.textContent = final; }
    }, 34);
  }, delay);
}

/* ---------- init (and again for a section the theme editor re-renders) ---------- */
function init(root){
  initMarquees(root);
  $$('[data-product]', root).forEach(productView);
  $$('.cam-main', root).forEach(initFeed);
  if (!reduce) $$('[data-scramble]', root).forEach((el, i) => scramble(el, 250 + i * 180));
}
init(document);
tick(); setInterval(tick, 1000);
document.addEventListener('shopify:section:load', e => { init(e.target); tick(); });
})();
